(function () {
  'use strict';

  const VISITED_KEY = 'cs_visited_at';
  const TIMER_KEY = 'cs_timer_start';
  const DURATION = 10 * 60;
  const hours24 = 24 * 60 * 60 * 1000;

  // ── Cookie helpers ────────────────────────
  function csSet(key, value, hours) {
    const expires = new Date(Date.now() + hours * 3600000).toUTCString();
    document.cookie = key + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/';
  }
  function csGet(key) {
    const match = document.cookie.match(new RegExp('(?:^|; )' + key + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }
  function csDel(key) {
    document.cookie = key + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/';
  }

  // ── Se timer expirou nas últimas 24h → checkout
  const visited = csGet(VISITED_KEY);
  if (visited && (Date.now() - parseInt(visited)) < hours24) {
    window.location.href = '/checkout';
    return;
  }

  // ── Iniciar timer se não existe ainda ─────
  if (!csGet(TIMER_KEY)) {
    csSet(TIMER_KEY, Date.now(), 0.17); // expira em ~10 minutos
  }

  // ── Countdown ─────────────────────────────
  function getSecondsLeft() {
    const start = csGet(TIMER_KEY);
    if (!start) return 0;
    const elapsed = Math.floor((Date.now() - parseInt(start)) / 1000);
    return Math.max(0, DURATION - elapsed);
  }

  function tick() {
    const el = document.getElementById('cs-timer');
    if (!el) return;
    const left = getSecondsLeft();
    const m = Math.floor(left / 60);
    const s = left % 60;
    el.textContent = String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');
    const bar = document.getElementById('cs-bar');
    if (bar) bar.style.width = (left / DURATION * 100) + '%';
    if (left === 0) {
      csSet(VISITED_KEY, Date.now(), 24);
      csDel(TIMER_KEY);
      window.location.href = '/';
    }
  }
  tick();
  setInterval(tick, 1000);

  // ── Número aleatório de pessoas ───────────
  const proofEl = document.getElementById('cs-proof-count');
  if (proofEl) {
    const num = Math.floor(Math.random() * 53) + 37;
    proofEl.textContent = ((window.vczI18n&&window.vczI18n['offer.people_count_html'])||'{count} people').replace('{count}', num.toLocaleString('en'));
  }

  let suSelected = false;
  const tabSelected = new Map();

  // ── Segunda unidade ───────────────────────
  window.csToggleSecondUnit = function (card) {
    suSelected = !suSelected;
    card.classList.toggle('selected', suSelected);
    updateUI();
  };

  // ── Tabs ──────────────────────────────────
  window.csTab = function (tab, btn) {
    document.querySelectorAll('.cs-tab-btn').forEach(b => b.classList.remove('active'));
    document.querySelectorAll('.cs-tab-pane').forEach(p => p.classList.remove('active'));
    btn.classList.add('active');
    const pane = document.getElementById('cs-tab-' + tab);
    if (pane) pane.classList.add('active');
  };

  // ── Mudar produto irmão via dropdown ──────
  window.csSiblingChange = function (select) {
    const card = select.closest('.cs-product-card');
    const option = select.options[select.selectedIndex];
    const oldVariantId = card.dataset.variantId;
    const newVariantId = option.value;
    const newPrice = parseInt(option.dataset.price);
    const newOriginal = parseInt(option.dataset.original);

    card.dataset.variantId = newVariantId;
    card.dataset.price = newPrice;
    card.dataset.originalPrice = newOriginal;

    if (tabSelected.has(oldVariantId)) {
      tabSelected.delete(oldVariantId);
      tabSelected.set(newVariantId, { price: newPrice, originalPrice: newOriginal });
    }
    updateUI();
  };

  // ── Product cards ─────────────────────────
  window.csToggleProduct = function (card) {
    const variantId = card.dataset.variantId;
    const price = parseInt(card.dataset.price);
    const originalPrice = parseInt(card.dataset.originalPrice);

    if (tabSelected.has(variantId)) {
      tabSelected.delete(variantId);
      card.classList.remove('selected');
    } else {
      tabSelected.set(variantId, { price, originalPrice });
      card.classList.add('selected');
    }
    updateUI();
  };

  // ── Update UI ─────────────────────────────
  function fmt(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + '€';
  }

  function updateUI() {
    const suCard = document.getElementById('cs-su-card');
    let addNow = suSelected ? parseInt(suCard.dataset.price) : 0;
    let addWas = suSelected ? parseInt(suCard.dataset.originalPrice) : 0;
    let count = suSelected ? 1 : 0;

    tabSelected.forEach(({ price, originalPrice }) => {
      addNow += price;
      addWas += originalPrice;
      count++;
    });

    const saving = addWas - addNow;
    const hasSelection = count > 0;

    const elEmpty = document.getElementById('cs-added-empty');
    const elCount = document.getElementById('cs-added-count');
    const elSaving = document.getElementById('cs-added-saving');
    const elPrice = document.getElementById('cs-added-price');
    const elWas = document.getElementById('cs-added-was');
    const elNow = document.getElementById('cs-added-now');

    if (elEmpty) elEmpty.style.display = hasSelection ? 'none' : '';
    if (elCount) {
      elCount.style.display = hasSelection ? '' : 'none';
      elCount.innerHTML = (count > 1 ? ((window.vczI18n&&window.vczI18n['offer.items_added_other_html'])||'<span>{count}</span> items added') : ((window.vczI18n&&window.vczI18n['offer.items_added_one_html'])||'<span>{count}</span> item added')).replace('{count}', count);
    }
    if (elSaving) {
      elSaving.style.display = hasSelection && saving > 0 ? '' : 'none';
      elSaving.textContent = saving > 0 ? ((window.vczI18n&&window.vczI18n['offer.you_save_html'])||'You save {amount}').replace('{amount}', fmt(saving)) : '';
    }
    if (elPrice) elPrice.style.display = hasSelection ? '' : 'none';
    if (elWas) {
      elWas.textContent = saving > 0 ? fmt(addWas) : '';
      elWas.style.display = saving > 0 ? 'block' : 'none';
    }
    if (elNow) elNow.textContent = fmt(addNow);

    const btnNone = document.getElementById('cs-btn-none');
    const btnSelected = document.getElementById('cs-btn-selected');
    if (btnNone) btnNone.style.display = hasSelection ? 'none' : 'flex';
    if (btnSelected) btnSelected.style.display = hasSelection ? 'flex' : 'none';
  }

  // ── Scroll dots ───────────────────────────
  function setupDots(scrollId, dotsId) {
    const scroll = document.getElementById(scrollId);
    const dotsContainer = document.getElementById(dotsId);
    if (!scroll || !dotsContainer) return;
    scroll.addEventListener('scroll', () => {
      const max = scroll.scrollWidth - scroll.clientWidth;
      if (max <= 0) return;
      const pct = scroll.scrollLeft / max;
      const dotEls = dotsContainer.querySelectorAll('.cs-scroll-dot');
      const active = Math.round(pct * (dotEls.length - 1));
      dotEls.forEach((d, i) => d.classList.toggle('active', i === active));
    });
  }
  setupDots('cs-scroll-her', 'cs-dots-her');
  setupDots('cs-scroll-him', 'cs-dots-him');

  // ── Adicionar ao carrinho e checkout ──────
  window.csAddToCartAndCheckout = async function () {
    const btn = document.getElementById('cs-btn-add');
    if (btn) { btn.disabled = true; btn.textContent = (window.vczI18n&&window.vczI18n['offer.processing_html'])||'Processing...'; }

    const items = [];
    const suCard = document.getElementById('cs-su-card');

    if (suSelected) {
      items.push({
        id: parseInt(suCard.dataset.variantId),
        quantity: 1,
        properties: { cross_sell: 'true' }
      });
    }

    tabSelected.forEach((_, variantId) => {
      items.push({
        id: parseInt(variantId),
        quantity: 1,
        properties: { cross_sell: 'true' }
      });
    });

    if (items.length === 0) {
      window.location.href = '/checkout';
      return;
    }

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      });
      if (!res.ok) throw new Error('Error adding to cart');
      csDel(TIMER_KEY);
      window.location.href = '/checkout';
    } catch (err) {
      console.error(err);
      if (btn) {
        btn.disabled = false;
        btn.textContent = (window.vczI18n&&window.vczI18n['offer.add_and_checkout_html'])||'Add and go to checkout';
      }
    }
  };

  updateUI();

})();
